﻿import Splide from "@splidejs/splide";
import { getFetch } from "./utilidades/getFetch";
import { isNullOrEmpty } from "./utilidades/isNullOrEmpty";


const hotsiteEmployerPage = {
    Templates: {
        templateItemRedeSocial(data){
            const html = [];
            data.forEach(item => {
                html.push(`
                    <div class="rede-social-item">
                        <a href="${item.url}" class="text-secondary"><i class="bi ${item.redeSocialIconeConvertido} hover-rede-social"></i></a>
                    </div>`)
            });

            return html.join('');
        },
        templateItemEndereco(data){
            const html = [];
            data.forEach(item => {
                html.push(`
                <div class="item-indereco">
                    <p itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
                        <b>${item.titulo}: </b>
                        <span itemprop="streetAddress">${item.logradouro}, ${item.numero} - ${item.bairro}. CEP: ${item.cep} - ${item.cidadeNome} </span>
                    </p>
                </div>
                `)
            });

            return html.join('');
        },
    },
    Splides: {
        splideGenerico() {
            const splideOptions = {
            start: 0,
            perPage: 2,
            focus: "start",
            trimSpace: true,
            arrows: true,
            pagination: false,
            autoWidth: true,
            gap: "1.2rem",
            };
            if (document.contains(document.querySelector(".splide-generico"))) {
            const splidesGen = document.querySelectorAll(".splide-generico");
            splidesGen.forEach((slide) => {
                const splide = new Splide(`#${slide.id}`, splideOptions);
                splide.mount();
            });
            }
        },
        init() {
            this.splideGenerico();
        },
    },
    async LighBox() {
            if (document.contains(document.getElementById("section-fotos"))) {
                
                const { default: SimpleLightbox } = await import("simplelightbox");
                let lightbox = new SimpleLightbox(".galeria-imagens a");
            }
        },
    async ObterInfoFooter(){
        const isHome = document.getElementById('hotsite-employer-page');
        const footer = document.querySelector('footer');

        if(isHome || !footer)
            return;

        const url = `/${CULTURE_EMPREGARE}/FanPage/DetalhesJson?empresaID=${111}`;

        const callbackSucesso = (data) => {
            const fanPage = data.data;

            const linkSite = footer.querySelector('.link-site');
            if(!isNullOrEmpty(fanPage.site)){
                const linkSiteSpan = footer.querySelector('.link-site-span');

                linkSite.href = fanPage.site;
                linkSiteSpan.textContent = fanPage.site;
            }
            else
                linkSite.classList.add('hide');

            const containerRedeSocial = footer.querySelector('.container-rede-social');

            if(fanPage.redesSociaisIcones && fanPage.redesSociaisIcones.length > 0)
                containerRedeSocial.innerHTML = this.Templates.templateItemRedeSocial(fanPage.redesSociaisIcones);
            else
                containerRedeSocial.classList.add('hide');

            const containerAnoFundacao = footer.querySelector('.container-ano-fundacao');
            const containerAreaNome = footer.querySelector('.container-area-nome');

            if(fanPage.anoFundacao && !isNullOrEmpty(fanPage.anoFundacao))
                containerAnoFundacao.querySelector('p').textContent = fanPage.anoFundacao;
            else
                containerAnoFundacao.classList.add('hide');

            if(fanPage.areaNome && !isNullOrEmpty(fanPage.areaNome))
                containerAreaNome.querySelector('p').textContent = fanPage.areaNome;
            else
                containerAreaNome.classList.add('hide');

            const containerEnderecos = footer.querySelector('.container-endereco');

            if(fanPage.enderecos && fanPage.enderecos.length > 0)
                containerEnderecos.innerHTML = this.Templates.templateItemEndereco(fanPage.enderecos);
            else
            containerEnderecos.classList.add('hide');
        };

        await getFetch(url, callbackSucesso, null, null);

    },
    Init(){
        this.Splides.init();
        this.LighBox();
        this.ObterInfoFooter();

    }
};


hotsiteEmployerPage.Init();